// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bonus-offer-row {
  border: 1px solid #dddddd;
  margin-bottom: 4px;
}
.bonus-offer-row .bonus-offer-section {
  display: flex;
  align-items: center;
}
.bonus-offer-row .bonus-offer-section p {
  margin-top: 4px;
  margin-left: 15px;
}
.bonus-offer-row .bonus-offer-section img {
  border: 1px solid #dddddd;
  height: 50px;
  width: 50px;
}
.bonus-offer-row p.expiry-date {
  font-size: 12px;
  font-weight: 700;
  margin: 0 !important;
}
.bonus-offer-row ion-button {
  min-width: 100px;
}

.temp-class {
  margin-top: 550px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/bonus-offers/bonus-offers.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;AACR;AACQ;EACI,eAAA;EACA,iBAAA;AACZ;AAGQ;EACI,yBAAA;EACA,YAAA;EACA,WAAA;AADZ;AAKI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AAHR;AAMI;EACI,gBAAA;AAJR;;AASA;EACI,iBAAA;AANJ","sourcesContent":[".bonus-offer-row{\r\n    border: 1px solid #dddddd;\r\n    margin-bottom: 4px;\r\n\r\n    .bonus-offer-section{\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        p{\r\n            margin-top: 4px;\r\n            margin-left: 15px;\r\n        }\r\n\r\n        \r\n        img{\r\n            border: 1px solid #dddddd;\r\n            height: 50px;\r\n            width: 50px;\r\n        }\r\n    }\r\n    \r\n    p.expiry-date{\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n        margin: 0!important;\r\n    }\r\n\r\n    ion-button{\r\n        min-width: 100px;\r\n    }\r\n\r\n}\r\n\r\n.temp-class{\r\n    margin-top: 550px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
